import { OccurrenceScope } from '../occurrence/occurrence.models';

export type UserRole = 'TENANT_ADMIN' | 'AGENT' | 'VIEWER';
export type UserStatus = 'INVITED' | 'ACTIVE' | 'DISABLED';

export interface User {
  readonly id: number;
  readonly name: string;
  readonly email: string;
  readonly role: UserRole;
  readonly status: UserStatus;
  /** Falso enquanto o convite não for aceite: o acesso ainda não existe, apesar do estado. */
  readonly passwordSet: boolean;
  readonly createdAt: string;
}

/**
 * Acesso a um módulo. No modelo GBT cada módulo é um âmbito de ocorrências: o papel diz o que
 * se pode fazer, isto diz em que módulos — e entre que datas se vêem os registos.
 */
export interface UserModule {
  readonly scope: OccurrenceScope;
  canView: boolean;
  canEdit: boolean;
  /** Abrir ocorrências no módulo — quem edita não cria necessariamente. */
  canCreate: boolean;
  canExport: boolean;
  accessFrom: string | null;
  accessTo: string | null;
}

export interface InviteUserPayload {
  name: string;
  email: string;
  role: UserRole;
}

export interface InviteUserResult {
  readonly user: User;
  readonly inviteUrl: string;
}

export const ROLE_LABELS: Record<UserRole, string> = {
  TENANT_ADMIN: 'Administrador',
  AGENT: 'Gestor',
  VIEWER: 'Observador',
};

export const ROLE_DESCRIPTIONS: Record<UserRole, string> = {
  TENANT_ADMIN: 'Acesso total, incluindo configurações e utilizadores.',
  AGENT: 'Regista e trata ocorrências e clientes; não altera configurações.',
  VIEWER: 'Somente leitura.',
};

export const ROLE_OPTIONS: readonly { readonly value: UserRole; readonly label: string }[] = [
  { value: 'TENANT_ADMIN', label: 'Administrador' },
  { value: 'AGENT', label: 'Gestor' },
  { value: 'VIEWER', label: 'Observador' },
];

export const STATUS_LABELS: Record<UserStatus, string> = {
  INVITED: 'Convidado',
  ACTIVE: 'Ativo',
  DISABLED: 'Inativo',
};
